import React from 'react'
import {
  Callback,
  WithDataCy
} from '@/layouts/core/types/core'
import { Typography } from '@mui/material'

export type ChronoLinkButtonProps = {
  onClick: Callback
  sx?: any
  children: React.ReactNode
} & WithDataCy

const ChronoLinkButton = (props: ChronoLinkButtonProps) => {
  const {
    onClick,
    sx = {},
    children
  } = props
  
  return (
    <a
      data-cy={props['data-cy']}
      href={'#'}
      style={{
        textDecoration: 'none'
      }}
      onClick={(event) => {
        event.preventDefault()
        onClick()
        return false
      }}>
      <Typography sx={{
        color: 'primary.main',
        textDecoration: 'none',
        textAlign: 'center',
        ...sx
      }}>
        {children}
      </Typography>
    </a>
  )
}

export default ChronoLinkButton